import {Component} from 'react';
import h from 'react-hyperscript';
import {NavLink} from 'react-router-dom';
import MobileNav from 'Components/Header/MobileNav/MobileNav';
import content from 'Assets/data/header.json';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
    };
  }

  toggleDrawer() {
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen,
    });
  }

  render() {
    return (
      h('nav', {
        id: 'header__nav',
        key: 'header__nav',
        className: 'nav',
      },
      h('div', {
        className: 'nav__list nav__list--left',
      }, [

        h('span', {
          id: 'header__hamburger-icon',
          key: 'header__hamburger-icon',
          className: 'hamburger material-icons',
          onClick: () => {
            this.toggleDrawer(true);
          },
          tabIndex: 0,
        }, 'menu'),

        h(NavLink, {
          key: 'header__product-name',
          id: 'header__product-name',
          to: '/app/',
          className: 'padding-right--sm text--grey',
          tabIndex: 0,
        }, content.title),

        h(MobileNav, {
          id: 'header__mobile-nav',
          key: 'header__mobile-nav',
          open: this.state.isDrawerOpen,
          onClose: () => {
            this.toggleDrawer();
          },
          handleSettingsOpen: this.props.handleSettingsOpen,
          needsDistrictConfig: this.props.needsDistrictConfig,
          loginClick: this.props.loginClick,
          userStatus: this.props.userStatus,
          siteTitle: content.title,
          districtName: this.props.districtName,
          logoutClick: this.props.logoutClick,
          googleUser: this.props.googleUser,
          mobileLogin: this.props.mobileLogin,
          isAdmin: this.props.isAdmin,
        }),

      ])
      )
    );
  }
}

export default Nav;
